import { useState, useEffect } from "react";
import { validateImageFile } from "../utils/avatarValidation";

export const useAvatarCrop = (uploadHandler, currentAvatar, setErrorState) => {
  const [avatarCropOpen, setAvatarCropOpen] = useState(false);
  const [avatarCropImage, setAvatarCropImage] = useState(null);
  const [avatarLoading, setAvatarLoading] = useState(false);

  useEffect(() => {
    if (currentAvatar) setAvatarLoading(true);
  }, [currentAvatar]);

  const handleAvatarFileSelect = (e) => {
    const file = e.target.files?.[0];
    if (!validateImageFile(file, setErrorState)) {
      e.target.value = "";
      return;
    }
    setAvatarCropImage(file);
    setAvatarCropOpen(true);
    e.target.value = "";
  };

  const handleAvatarCropConfirm = async (croppedFile) => {
    setAvatarLoading(true);
    try {
      await uploadHandler(croppedFile, "avatar");
      setAvatarCropImage(null);
      setAvatarCropOpen(false);
    } catch {
      setAvatarLoading(false);
    }
  };

  const avatarCropCancel = () => {
    setAvatarCropOpen(false);
    setAvatarCropImage(null);
  };

  return {
    avatarCropOpen,
    avatarCropImage,
    avatarLoading,
    setAvatarLoading,
    handleAvatarFileSelect,
    handleAvatarCropConfirm,
    avatarCropCancel,
  };
};
